module.exports = __webpack_public_path__ + "static/media/fussier.0ab8f82b.jpg";